<div class="pt-4">
    @if (!deposit()) {
        <app-loading />
    } @else {
        <form
            class="flex flex-col gap-11"
            [formGroup]="formGroup!">
            <app-input-text
                [disabled]="true"
                [inputFormControl]="formGroup!.controls.name"
                [label]="'depositName' | transloco"
                [placeholder]="'depositName' | transloco" />

            <app-expansion-panel [isExpanded]="true">
                <div
                    class="flex flex-row"
                    header>
                    <span class="font-medium text-xl items-center">
                        {{
                            'layersCreated'
                                | transloco
                                    : {
                                          COUNT: createDepositLayerService.allCreatedLayersCount(),
                                      }
                        }}
                    </span>
                    <span class="pt-1 pl-2">({{ createDepositLayerService.allCreatedLayersCount() }})</span>
                </div>

                <div
                    class="flex flex-col gap-4"
                    content>
                    @for (table of createDepositLayerService.createdTables(); track table.name) {
                        <p>{{ table.name }}</p>
                    }

                    @for (table of createDepositLayerService.newCreatedLayers(); track table.name) {
                        <p>
                            {{ table.name }}
                            <span class="text-xs font-normal italic text-custom-blue mx-1">
                                {{ 'created' | transloco: { GENDER: 'feminine' } }}
                            </span>
                        </p>
                    }

                    @if (!createDepositLayerService.allCreatedLayersCount()) {
                        <span class="text-outline font-normal">{{ 'noLayerCreated' | transloco }}</span>
                    }
                    <app-button
                        [icon]="['fas', 'plus']"
                        [label]="'addLayer' | transloco"
                        [type]="ButtonType.PRIMARY"
                        (onClick)="openAddLayerModal()" />
                </div>
            </app-expansion-panel>
        </form>
    }
</div>
